import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "title-element default" }
const _hoisted_3 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_AppIcon = _resolveComponent("AppIcon")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.title), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (title, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        (title.link)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: _normalizeClass(`title-element ${title.selected ? 'selected' : null}`),
              to: title.link
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AppIcon, {
                  mdi: "",
                  icon: "chevron-right",
                  medium: ""
                }),
                _createElementVNode("h2", null, _toDisplayString(title.name), 1)
              ]),
              _: 2
            }, 1032, ["class", "to"]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(`title-element ${title.selected ? 'selected' : null}`),
              onClick: $event => (_ctx.titleElementClick(title.id ? title.id : title.name))
            }, [
              _createVNode(_component_AppIcon, {
                mdi: "",
                icon: "chevron-right",
                medium: ""
              }),
              _createElementVNode("h2", null, _toDisplayString(title.name), 1)
            ], 10, _hoisted_3))
      ], 64))
    }), 128))
  ]))
}